import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { ChallanInModel } from '../model/index';

@Injectable()
export class ChallanInService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });

    private challaninUrl = 'api/challanIn';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getChallaninList(query: any): Promise<ChallanInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.challaninUrl}/getChallaninList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

     getChallanInDetailList(query: any): Promise<ChallanInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.challaninUrl}/getChallanInDetailList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

     addChallanIn(query: any): Promise<ChallanInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.challaninUrl}/addChallanIn`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    //  deleteGridList(rowData: any): Promise<ChallanInModel> {
    //     const url = `${this.challaninUrl}/deleteGridList`;
    //     return this.http
    //         .post(url, $.param(rowData), { headers: this.headers })
    //         .toPromise()
    //         .then(res => res.json() as ChallanInModel)
    //         .catch(this.handleError);
    // }
    //
    // getTestingbill(client_id: number): Promise<ChallanInModel> {
    //     const url = `${this.challaninUrl}/clientList?client_id=${client_id}`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(response => response.json().data as ChallanInModel)
    //         .catch(this.handleError);
    // }
    //
    // getTestingbillClientList(): Promise<any> {
    //     const url = `${this.challaninUrl}/getTestingbillClientList`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(this.handleError);
    // }
    //
    // getTestingtypeList(): Promise<any> {
    //     const url = `${this.challaninUrl}/getTestingtypeList`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(this.handleError);
    // }

    deleteChallanin(rowData: any): Promise<ChallanInModel> {
        const url = `${this.challaninUrl}/deleteChallanin`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ChallanInModel)
            .catch(this.handleError);
    }

    addUpdateChallanin(challanindetail: any): Promise<ChallanInModel> {

        const url = `${this.challaninUrl}/addUpdateChallanin`;

        return this.http
            .post(url, $.param(challanindetail), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ChallanInModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/challanIn.service.ts